<div id="{{id}}" class="{{#if hideCriteriaFirstTime}}hidden{{/if}}">
    <field-item item="criteriaFormModel">
        <field-hcombo id="criteria-selectByType" name="type" label="" {options}="typeOptions"></field-hcombo>

        <field-radios label="" name="status" {options}="statuses" {visible}="states.status"></field-radios>

    </field-item>
</div>
